import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AuthorizationService } from 'src/services/authorization.service';
import { Router, ActivatedRoute } from '@angular/router';
import { IdentityService } from 'src/services/identity.service';
import { ClaimsEnum } from 'src/models/claims.enum';

@Component({
    selector: 'app-nav-top',
    templateUrl: './nav-top.component.html',
    styleUrls: ['./nav-top.component.css']
})
export class NavTopComponent implements OnInit {
    formId: number;
    routeSub: any;

    // Roles
    corpsys = false;
    admin = false;
    requestor = false;
    approver = false;

    constructor(private router: Router, private _location: Location, public authService: AuthorizationService,
        private activatedRoute: ActivatedRoute, private identityService: IdentityService) { }

    ngOnInit() {
        if (this.authService.authenticated()) {
            const role = this.authService.getRoles();
            switch (role[0]) {
                case ClaimsEnum.LegalAdApprove:
                    this.approver = true;
                    break;
                case ClaimsEnum.LegalAdAdmin:
                    this.admin = true;
                    break;
                case ClaimsEnum.LegalAdCorpSystems:
                    this.corpsys = true;
                    break;
                case ClaimsEnum.LegalAdRequest:
                    this.requestor = true;
                    break;
                default:
                    break;
            }
        }
    }

    ngOnDestroy() {
        if (this.routeSub)
            this.routeSub.unsubscribe();
    }

    login(): void {
        this.authService.login();
    }

    logout(): void {
        this.authService.logout();
        if (this.router.url === "/form")
            this.router.navigate(["/home"]);
    }

    get authenticated(): boolean {
        return this.authService.authenticated();
    }

    get existingForm(): boolean {
        if (this.activatedRoute.firstChild) {
            this.formId = this.activatedRoute.firstChild.snapshot.params['id']
            return (this.formId && this.formId >= 0);
        }
        return false;
    }
}
